import React, { useState, useEffect } from "react";
import "bootstrap/dist/css/bootstrap.min.css";
import { FaGithub, FaLinkedin, FaTwitter, FaArrowUp, FaCode, FaServer, FaMobile, FaEnvelope  } from "react-icons/fa";
import { motion, AnimatePresence } from "framer-motion";
import "./App.css";
import proyecto1 from "./imagenes/proyecto1.png";

const App = () => {
  const [darkMode, setDarkMode] = useState(false);
  const [scrolled, setScrolled] = useState(false);
  const [activeSection, setActiveSection] = useState("home");
  const [projectFilter, setProjectFilter] = useState("all");

  useEffect(() => {
    const handleScroll = () => {
      setScrolled(window.scrollY > 50);
      
      const sections = ["home", "skills", "projects", "contact"];
      const currentSection = sections.find(section => {
        const el = document.getElementById(section);
        if (el) {
          const rect = el.getBoundingClientRect();
          return rect.top <= 150 && rect.bottom >= 150;
        }
        return false;
      });
      
      if (currentSection) {
        setActiveSection(currentSection);
      }
    };
    
    window.addEventListener("scroll", handleScroll);
    handleScroll();
    
    return () => window.removeEventListener("scroll", handleScroll);
  }, []);

  const scrollTo = (id) => {
    const element = document.getElementById(id);
    if (element) {
      window.scrollTo({
        top: element.offsetTop - 70,
        behavior: "smooth"
      });
    }
  };

  const allProjects = [
    {
      title: "Página Web Inmuebles JyB",
      description: "Página web creada con el objetivo de promocionar los inmuebles de la empresa Inmuebles JyB.",
      image: proyecto1,
      tags: ["HTML", "CSS", "JavaScript", "Bootstrap"],
      github: "https://github.com/username/proyecto1",
      demo: "https://inmueblesjyb.netlify.app/",
      category: "web"
    },
    {
      title: "Proyecto 2",
      description: "Sistema de gestión desarrollado con tecnologías modernas y enfoque en la experiencia de usuario.",
      image: "/images/proyecto2.jpg",
      tags: ["Next.js", "Tailwind CSS", "Firebase"],
      github: "https://github.com/username/proyecto2",
      demo: "https://proyecto2.demo.com",
      category: "app"
    },
    {
      title: "Proyecto 3",
      description: "Plataforma innovadora con interfaz intuitiva y diseño moderno.",
      image: "/images/proyecto3.jpg",
      tags: ["TypeScript", "GraphQL", "PostgreSQL"],
      github: "https://github.com/username/proyecto3",
      demo: "https://proyecto3.demo.com",
      category: "design"
    },
  ];

  const filteredProjects = projectFilter === "all" 
    ? allProjects 
    : allProjects.filter(project => project.category === projectFilter);

  const skills = [
    { 
      name: "Frontend", 
      icon: <FaCode size={30} />, 
      items: ["React", "HTML5/CSS3", "JavaScript", "Vue.js"],
      color: "#61DAFB"
    },
    { 
      name: "Backend", 
      icon: <FaServer size={30} />, 
      items: ["Node.js", "Python", "Java"],
      color: "#68A063"
    },
    { 
      name: "Mobile", 
      icon: <FaMobile size={30} />, 
      items: ["React Native", "Flutter", "Kotlin"],
      color: "#3DDC84"
    }
  ];

  return (
    <div className={darkMode ? "dark-mode" : "light-mode"}>
      <nav className={`navbar navbar-expand-lg fixed-top ${scrolled ? "navbar-scrolled" : ""} ${darkMode ? "navbar-dark" : "navbar-light"}`}>
        <div className="container">
          <motion.a 
            className="navbar-brand fw-bold"
            href="#home"
            initial={{ opacity: 0 }}
            animate={{ opacity: 1 }}
            transition={{ duration: 0.5 }}
          >
            <span className="primary-text">V</span>ictor <span className="primary-text">D</span>ávila
          </motion.a>
          
          <div className="d-flex align-items-center">
            <motion.ul 
              className="navbar-nav me-4 d-none d-lg-flex"
              initial={{ opacity: 0, y: -20 }}
              animate={{ opacity: 1, y: 0 }}
              transition={{ duration: 0.5, delay: 0.2 }}
            >
              <li className="nav-item">
                <a className={`nav-link ${activeSection === "home" ? "active" : ""}`} href="#home" onClick={(e) => { e.preventDefault(); scrollTo("home"); }}>Inicio</a>
              </li>
              <li className="nav-item">
                <a className={`nav-link ${activeSection === "skills" ? "active" : ""}`} href="#skills" onClick={(e) => { e.preventDefault(); scrollTo("skills"); }}>Habilidades</a>
              </li>
              <li className="nav-item">
                <a className={`nav-link ${activeSection === "projects" ? "active" : ""}`} href="#projects" onClick={(e) => { e.preventDefault(); scrollTo("projects"); }}>Proyectos</a>
              </li>
              <li className="nav-item">
                <a className={`nav-link ${activeSection === "contact" ? "active" : ""}`} href="#contact" onClick={(e) => { e.preventDefault(); scrollTo("contact"); }}>Contacto</a>
              </li>
            </motion.ul>
            
            <motion.button 
              onClick={() => setDarkMode(!darkMode)} 
              className="theme-toggle-button"
              whileHover={{ scale: 1.1 }}
              whileTap={{ scale: 0.9 }}
            >
              {darkMode ? "☀️" : "🌙"}
            </motion.button>
          </div>
        </div>
      </nav>

      <motion.button 
        className={`back-to-top ${scrolled ? "visible" : ""}`}
        onClick={() => scrollTo("home")}
        whileHover={{ scale: 1.1 }}
        whileTap={{ scale: 0.9 }}
      >
        <FaArrowUp />
      </motion.button>

      <header id="home" className="hero">
        <div className="container">
          <div className="row align-items-center">
            <motion.div 
              className="col-lg-6 hero-content"
              initial={{ opacity: 0, x: -50 }}
              animate={{ opacity: 1, x: 0 }}
              transition={{ duration: 0.8 }}
            >
              <div className="text-wrapper">
                <motion.h1
                  initial={{ opacity: 0, y: 20 }}
                  animate={{ opacity: 1, y: 0 }}
                  transition={{ duration: 0.5, delay: 0.2 }}
                >
                  <span className="greeting">Hola, soy</span>
                  <span className="name">Victor Dávila</span>
                  <span className="title">Desarrollador Full Stack</span>
                </motion.h1>
                <motion.p 
                  className="lead mb-4"
                  initial={{ opacity: 0 }}
                  animate={{ opacity: 1 }}
                  transition={{ duration: 0.5, delay: 0.4 }}
                >
                  Desarrollador con pasión por crear soluciones innovadoras y escalables.
                  Transformo ideas en experiencias digitales excepcionales.
                </motion.p>
                <motion.div 
                  className="hero-buttons"
                  initial={{ opacity: 0, y: 20 }}
                  animate={{ opacity: 1, y: 0 }}
                  transition={{ duration: 0.5, delay: 0.6 }}
                >
                  <motion.button 
                    onClick={() => scrollTo("projects")} 
                    className="btn btn-lg me-3 mb-2 btn-pe"
                    whileHover={{ scale: 1.05 }}
                    whileTap={{ scale: 0.95 }}
                  >
                    Ver Proyectos
                  </motion.button>
                  <motion.a 
                    href="#contact" 
                    className="btn btn-outline-dark btn-lg mb-2"
                    onClick={(e) => { e.preventDefault(); scrollTo("contact"); }}
                    whileHover={{ scale: 1.05 }}
                    whileTap={{ scale: 0.95 }}
                  >
                    Contacto
                  </motion.a>
                </motion.div>
              </div>
            </motion.div>
            <motion.div 
              className="col-lg-6 hero-image-container"
              initial={{ opacity: 0, x: 50 }}
              animate={{ opacity: 1, x: 0 }}
              transition={{ duration: 0.8 }}
            >
              <div className="hero-image">
                <div className="animated-shape"></div>
              </div>
            </motion.div>
          </div>
        </div>
        <div className="hero-wave">
          <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 1440 320">
            <path fill={darkMode ? "#1a1a1a" : "#ffffff"} fillOpacity="1" d="M0,192L48,197.3C96,203,192,213,288,229.3C384,245,480,267,576,250.7C672,235,768,181,864,170.7C960,160,1056,192,1152,197.3C1248,203,1344,181,1392,170.7L1440,160L1440,320L1392,320C1344,320,1248,320,1152,320C1056,320,960,320,864,320C768,320,672,320,576,320C480,320,384,320,288,320C192,320,96,320,48,320L0,320Z"></path>
          </svg>
        </div>
      </header>

      <section id="skills" className="skills-section">
        <div className="container">
          <motion.h2 
            className="section-title text-center"
            initial={{ opacity: 0, y: 20 }}
            whileInView={{ opacity: 1, y: 0 }}
            viewport={{ once: true }}
            transition={{ duration: 0.5 }}
          >
            Mis Habilidades
          </motion.h2>
          <div className="row">
            {skills.map((skill, index) => (
              <motion.div 
                key={index} 
                className="col-md-4 mb-4"
                initial={{ opacity: 0, y: 30 }}
                whileInView={{ opacity: 1, y: 0 }}
                viewport={{ once: true }}
                transition={{ duration: 0.5, delay: index * 0.2 }}
              >
                <motion.div 
                  className="skill-card"
                  whileHover={{ y: -10 }}
                  style={{ borderTop: `4px solid ${skill.color}` }}
                >
                  <div className="skill-icon" style={{ color: skill.color }}>{skill.icon}</div>
                  <h3>{skill.name}</h3>
                  <ul className="skill-list">
                    {skill.items.map((item, i) => (
                      <motion.li 
                        key={i}
                        initial={{ opacity: 0, x: -20 }}
                        whileInView={{ opacity: 1, x: 0 }}
                        viewport={{ once: true }}
                        transition={{ duration: 0.3, delay: i * 0.1 }}
                      >
                        {item}
                      </motion.li>
                    ))}
                  </ul>
                </motion.div>
              </motion.div>
            ))}
          </div>
        </div>
      </section>

      <section id="projects" className="projects-section">
        <div className="container">
          <motion.h2 
            className="section-title text-center"
            initial={{ opacity: 0, y: 20 }}
            whileInView={{ opacity: 1, y: 0 }}
            viewport={{ once: true }}
            transition={{ duration: 0.5 }}
          >
            Proyectos
          </motion.h2>
          
          <motion.div 
            className="project-filters text-center mb-5"
            initial={{ opacity: 0, y: 20 }}
            whileInView={{ opacity: 1, y: 0 }}
            viewport={{ once: true }}
            transition={{ duration: 0.5, delay: 0.2 }}
          >
            {["all", "web", "app", "design"].map((filter, index) => (
              <motion.button 
                key={filter}
                className={`filter-btn ${projectFilter === filter ? "active" : ""}`}
                onClick={() => setProjectFilter(filter)}
                whileHover={{ scale: 1.05 }}
                whileTap={{ scale: 0.95 }}
                initial={{ opacity: 0, y: 20 }}
                animate={{ opacity: 1, y: 0 }}
                transition={{ duration: 0.3, delay: index * 0.1 }}
              >
                {filter.charAt(0).toUpperCase() + filter.slice(1)}
              </motion.button>
            ))}
          </motion.div>
          
          <div className="row">
            <AnimatePresence>
              {filteredProjects.map((project, index) => (
                <motion.div 
                  key={project.title}
                  className="col-12 col-md-6 col-lg-4 mb-4"
                  initial={{ opacity: 0, y: 30 }}
                  whileInView={{ opacity: 1, y: 0 }}
                  exit={{ opacity: 0, y: 30 }}
                  viewport={{ once: true }}
                  transition={{ duration: 0.5, delay: index * 0.2 }}
                >
                  <motion.div 
                    className="project-card"
                    whileHover={{ y: -10 }}
                  >
                    <div className="project-image">
                      <img src={project.image} alt={project.title} />
                      <div className="project-overlay">
                        <div className="project-links">
                          <motion.a 
                            href={project.github} 
                            target="_blank" 
                            rel="noopener noreferrer"
                            whileHover={{ scale: 1.1 }}
                            whileTap={{ scale: 0.9 }}
                          >
                            <FaGithub size={24} />
                          </motion.a>
                          <motion.a 
                            href={project.demo} 
                            target="_blank" 
                            rel="noopener noreferrer"
                            whileHover={{ scale: 1.1 }}
                            whileTap={{ scale: 0.9 }}
                          >
                            Ver Demo
                          </motion.a>
                        </div>
                      </div>
                    </div>
                    <div className="project-content">
                      <h3>{project.title}</h3>
                      <p>{project.description}</p>
                      <div className="project-tags">
                        {project.tags.map((tag, tagIndex) => (
                          <motion.span 
                            key={tagIndex} 
                            className="project-tag"
                            initial={{ opacity: 0, scale: 0.8 }}
                            animate={{ opacity: 1, scale: 1 }}
                            transition={{ duration: 0.3, delay: tagIndex * 0.1 }}
                          >
                            {tag}
                          </motion.span>
                        ))}
                      </div>
                    </div>
                  </motion.div>
                </motion.div>
              ))}
            </AnimatePresence>
          </div>
          
          {filteredProjects.length === 0 && (
            <motion.div 
              className="text-center py-5"
              initial={{ opacity: 0 }}
              animate={{ opacity: 1 }}
              transition={{ duration: 0.5 }}
            >
              <p>No hay proyectos disponibles en esta categoría.</p>
            </motion.div>
          )}
        </div>
      </section>

      <section id="contact" className="contact-section">
        <div className="container text-center">
          <motion.h2 
            className="section-title"
            initial={{ opacity: 0, y: 20 }}
            whileInView={{ opacity: 1, y: 0 }}
            viewport={{ once: true }}
            transition={{ duration: 0.5 }}
          >
            Contacto
          </motion.h2>
          <motion.p 
            className="contact-intro"
            initial={{ opacity: 0 }}
            whileInView={{ opacity: 1 }}
            viewport={{ once: true }}
            transition={{ duration: 0.5, delay: 0.2 }}
          >
            ¿Interesado en trabajar juntos? ¡Contáctame!
          </motion.p>
          
          <motion.div 
            className="contact-form-container"
            initial={{ opacity: 0, y: 30 }}
            whileInView={{ opacity: 1, y: 0 }}
            viewport={{ once: true }}
            transition={{ duration: 0.5, delay: 0.3 }}
          >
            <form className="contact-form">
              <div className="row">
                <div className="col-md-6 mb-3">
                  <motion.input 
                    type="text" 
                    className="form-control" 
                    placeholder="Nombre"
                    whileFocus={{ scale: 1.02 }}
                  />
                </div>
                <div className="col-md-6 mb-3">
                  <motion.input 
                    type="email" 
                    className="form-control" 
                    placeholder="Email"
                    whileFocus={{ scale: 1.02 }}
                  />
                </div>
              </div>
              <div className="mb-3">
                <motion.input 
                  type="text" 
                  className="form-control" 
                  placeholder="Asunto"
                  whileFocus={{ scale: 1.02 }}
                />
              </div>
              <div className="mb-3">
                <motion.textarea 
                  className="form-control" 
                  rows="5" 
                  placeholder="Mensaje"
                  whileFocus={{ scale: 1.02 }}
                />
              </div>
              <motion.button 
                type="submit" 
                className="btn btn-pe"
                whileHover={{ scale: 1.05 }}
                whileTap={{ scale: 0.95 }}
              >
                Enviar Mensaje
              </motion.button>
            </form>
          </motion.div>
          
          <motion.div 
            className="social-links"
            initial={{ opacity: 0, y: 20 }}
            whileInView={{ opacity: 1, y: 0 }}
            viewport={{ once: true }}
            transition={{ duration: 0.5, delay: 0.5 }}
          >
            {[
              { icon: <FaGithub size={24} />, url: "https://github.com/EReysner" },
              { icon: <FaLinkedin size={24} />, url: "https://linkedin.com" },
              { icon: <FaTwitter size={24} />, url: "https://twitter.com" },
              { icon: <FaEnvelope size={24} />, url: "mailto:contact@example.com" }
            ].map((social, index) => (
              <motion.a
                key={index}
                href={social.url}
                target="_blank"
                rel="noopener noreferrer"
                className="social-icon"
                whileHover={{ y: -5, scale: 1.1 }}
                whileTap={{ scale: 0.9 }}
                initial={{ opacity: 0, y: 20 }}
                animate={{ opacity: 1, y: 0 }}
                transition={{ duration: 0.3, delay: index * 0.1 }}
              >
                {social.icon}
              </motion.a>
            ))}
          </motion.div>
        </div>
      </section>

      <footer className="footer">
        <div className="container">
          <div className="row align-items-center">
            <motion.div 
              className="col-md-6"
              initial={{ opacity: 0 }}
              whileInView={{ opacity: 1 }}
              viewport={{ once: true }}
              transition={{ duration: 0.5 }}
            >
              <p>&copy; 2025 Victor Dávila - Todos los derechos reservados</p>
            </motion.div>
            <motion.div 
              className="col-md-6 text-md-end"
              initial={{ opacity: 0 }}
              whileInView={{ opacity: 1 }}
              viewport={{ once: true }}
              transition={{ duration: 0.5, delay: 0.2 }}
            >
              <motion.a 
                href="#home" 
                onClick={(e) => { e.preventDefault(); scrollTo("home"); }} 
                className="footer-link"
                whileHover={{ scale: 1.1 }}
                whileTap={{ scale: 0.9 }}
              >
                Volver arriba
              </motion.a>
            </motion.div>
          </div>
        </div>
      </footer>
    </div>
  );
};

export default App;